module.exports = __webpack_public_path__ + "static/media/22.6b8ba5bc.png";